import type { CSSProperties, ElementType, ReactNode } from 'react';
import { styleVars } from '../lib/style.ts';

export interface RowProps {
  children: ReactNode;
  gap?: string;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
  as?: ElementType;
  className?: string;
}

/** Horizontal group that wraps. Use for toolbars, label/value pairs, action clusters. */
export function Row({ children, gap, align, justify, as: Tag = 'div', className }: RowProps) {
  return (
    <Tag
      className={['row', className].filter(Boolean).join(' ')}
      style={styleVars({
        '--gap': gap,
        '--align': typeof align === 'string' ? align : undefined,
        '--justify': typeof justify === 'string' ? justify : undefined,
      })}
    >
      {children}
    </Tag>
  );
}
